export default {"src":"/_next/static/media/gcf_white_01.15233505.svg","height":80,"width":346,"blurWidth":0,"blurHeight":0};